module.exports = __webpack_public_path__ + "img/duct_simple_4way.f5d3f715.svg";